import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@/styles/index.css'
import { CockpitApp } from '@/app/CockpitApp'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CockpitApp />
  </StrictMode>,
)
